export default {"src":"/_next/static/media/share-icon.04557fb8.svg","height":800,"width":800};